<!-- Poner un módulo en mantenimiento o cambiarle el aviso (16/10/2026). -->
<section class="app-dialog mm-dialogo">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="mm-dialogo__icono" aria-hidden="true">
        <span class="material-icons">construction</span>
      </span>
      <div>
        <p class="app-dialog__eyebrow mm-dialogo__grupo">{{ datos.opcion.grupo }}</p>
        <h2 [id]="idTitulo">{{ esCambio ? "Cambiar el aviso" : "Poner en mantenimiento" }}</h2>
        <p class="mm-dialogo__nombre">{{ datos.opcion.nombre }}</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close" aria-label="Cerrar" [disabled]="enviando()" (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content mm-dialogo__contenido">
    <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
      <mat-label>Aviso para quien quiera entrar</mat-label>
      <textarea matInput id="mmDialogoMensaje" aria-label="Aviso para quien quiera entrar" rows="3" [maxlength]="largoMensaje" [placeholder]="porOmision"
                [ngModel]="mensaje()" (ngModelChange)="cambiaMensaje($event)" [disabled]="enviando()"></textarea>
      <mat-hint>Si lo dejas vacío, sale el de siempre.</mat-hint>
      <mat-hint align="end">{{ mensaje().length }}/{{ largoMensaje }}</mat-hint>
    </mat-form-field>

    <fieldset class="mm-dialogo__cuando" [disabled]="enviando()">
      <legend>¿Hasta cuándo?</legend>
      <label class="mm-dialogo__opcion" [class.is-on]="!conFecha()">
        <input type="radio" name="mmCuando" [checked]="!conFecha()" (change)="cambiaFecha(false)" />
        <span>Hasta que alguien lo termine</span>
      </label>
      <label class="mm-dialogo__opcion" [class.is-on]="conFecha()">
        <input type="radio" name="mmCuando" [checked]="conFecha()" (change)="cambiaFecha(true)" />
        <span>Hasta una fecha (después vuelve solo)</span>
      </label>
    </fieldset>

    @if (conFecha()) {
      <div class="mm-dialogo__regreso">
        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Día en que vuelve</mat-label>
          <input matInput readonly aria-label="Día en que vuelve" placeholder="dd/mm/aaaa" [matDatepicker]="calendario" [min]="hoy"
                 [ngModel]="dia()" (ngModelChange)="cambiaDia($event)" (click)="calendario.open()" [disabled]="enviando()" />
          <mat-datepicker-toggle matIconSuffix [for]="calendario" />
          <mat-datepicker #calendario />
        </mat-form-field>
        <mat-form-field appearance="outline" class="table-page__field" subscriptSizing="dynamic">
          <mat-label>Hora</mat-label>
          <mat-select [ngModel]="hora()" (ngModelChange)="cambiaHora($event)" [disabled]="enviando() || !dia()">
            @for (h of horas(); track h.valor) {
              <mat-option [value]="h.valor" [disabled]="h.pasada">{{ h.valor }}</mat-option>
            }
          </mat-select>
          @if (!dia()) {
            <mat-hint>Primero escoge el día.</mat-hint>
          }
        </mat-form-field>
      </div>
    }

    <div class="mm-dialogo__vista">
      <span class="mm-dialogo__vista-titulo">Así lo verán</span>
      <p>{{ vistaPrevia() }}</p>
    </div>

    @if (error()) {
      <p class="mm-dialogo__error" aria-live="assertive">{{ error() }}</p>
    }
  </div>

  <footer mat-dialog-actions class="app-dialog__footer">
    <button type="button" class="app-form-btn app-form-btn--secondary" [disabled]="enviando()" (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" class="app-form-btn app-form-btn--primary" [disabled]="enviando()" [attr.aria-busy]="enviando()"
            (click)="guardar()">
      {{ enviando() ? "Guardando…" : esCambio ? "Guardar cambios" : "Poner en mantenimiento" }}
    </button>
  </footer>
</section>
